var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"public-long-desc"},[_c('md-card',{staticClass:"md-card-unspaced public-long-desc-card rfider-shadow"},[_c('md-card-content',[_c('public-expand',{attrs:{"item":_vm.item,"refKey":"longDescription"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }